<div class="add-fav-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="mg-btm-32">Save to Favorite Orders</h2>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="text-center ng-star-inserted message">
        You may save this order for easy re-ordering in the future. It can be changed on your account page.
      </h2>
    </div>
  </div>

  <div class="row mg-top-32">
    <form name="favForm" (ngSubmit)="onSubmit(favForm.value);" [formGroup]="favForm" novalidate>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group" [ngClass]="{ 'ng-invalid': !favForm.controls.favName.valid}">
          <input type="text" class="form-control" id="favName" name="favName" formControlName="favName" maxlength ="25"/>
          <app-validation-message [control]="favForm.controls.favName" class="form-error" [updateOn]="updateTrigger.Dirty"></app-validation-message>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
        <button type="submit" [disabled]="loading || !favForm.valid" class="btn wb-btn-default center-block">
          Save as Favorite
          <span *ngIf="loading" class="loading-animation"></span>
        </button>
      </div>
    </form>
    <button (click)='cancel()' class="btn wb-btn-outline text-center mg-top-24 mg-btm-9 ng-star-inserted">Cancel</button>
  </div>

</div>
